import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Accordion, Card } from "react-bootstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { AdminService } from "../../../services/admin-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ToastContainer } from "react-toastify";

export const Content = (props) => {
  const history = useHistory();
  const [submitloading, setSubmitLoading] = useState(true);


  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
      setSubmitLoading(false);
    try {
      await AdminService.adminForgotPassword(values.email);

      setSubmitLoading(true);
        notify("Successfully Send OTP Code");
        history.replace(`/password-reset-validate-code?email=` + values.email)
      
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  return (
    <div className="ms-content-wrapper ms-auth">
      <div>
        <ToastContainer />
      </div>
      <div className="ms-auth-container">
        <div className="ms-auth-col">
          <div className="ms-auth-bg" />
        </div>
        <div className="ms-auth-col">
          <div className="ms-auth-form">
            <Formik
              initialValues={{
                email: "",
              }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().email().required("Required"),
                })}

              onSubmit={onSubmitForm}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                touched,
                values,
                submitForm,
                isValid,
              }) => (
                <form>
                  <h3>Forgot Password?</h3>
                  <p>Enter your email to recover your password</p>
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">Email Address</label>
                    <div className="input-group">
                      <input
                        name="email"
                        type="email"
                        className="form-control"
                        id="validationCustom08"
                        placeholder="Email Address"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.email && errors.email}
                        </div>
                  </div>
                  <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                  </div>
                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    type="button"
                    onClick={submitForm}
                  >
                    Reset Password
                  </button>
                  <p className="mb-0 mt-3 text-center">
                    Go Back{" "}
                    <Link className="btn-link" to="/login">
                      Login
                    </Link>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
